// @flow

const allHealthAuthorities = [
  'bc', 'fha', 'iha', 'nha', 'vcha', 'viha',
];
const healthAuthorities = {
  'bc': {
    name: 'British Columbia',
    shortName: 'BC',
    cascadeKey: 'BC Overall',
    indicatorsKey: 'BC',
    hsda: [
      {
        key: 'fha',
        name: 'Fraser Health',
      },
      {
        key: 'iha',
        name: 'Interior Health',
      },
      {
        key: 'nha',
        name: 'Northern Health',
      },
      {
        key: 'vcha',
        name: 'Vancouver Coastal Health',
      },
      {
        key: 'viha',
        name: 'Vancouver Island Health',
        cascadeKey: 'Vancouver Island Health',
      },
    ],
  },
  'fha': {
    name: 'Fraser Health',
    indicatorsKey: 'FRASER',
    hsda: ['Fraser East', 'Fraser North', 'Fraser South'],
  },
  'iha': {
    name: 'Interior Health',
    indicatorsKey: 'INTERIOR',
    hsda: ['East Kootenay', 'Kootenay Boundary', 'Okanagan', 'Thompson Cariboo Shuswap'],
  },
  'viha': {
    name: 'Vancouver Island Health',
    shortName: 'Island Health',
    indicatorsKey: 'VANCOUVER ISLAND',
    hsda: ['Central Vancouver Island', 'North Vancouver Island', 'South Vancouver Island'],
    cascadeKey: 'Vancouver Island Health',
  },
  'nha': {
    name: 'Northern Health',
    indicatorsKey: 'NORTHERN',
    hsda: ['Northeast', 'Northern Interior', 'Northwest'],
  },
  'vcha': {
    name: 'Vancouver Coastal Health',
    indicatorsKey: 'VANCOUVER COASTAL',
    hsda: ['North Shore / Coast Garibaldi', 'Richmond', 'Vancouver'],
  },
};
const inputFiles = {
  bccdc: 'NewSTOPIndicators.xlsx',
  cascade: 'cascade.txt',
  indicators: 'indicators.csv',
  indicators_y: 'indicators_y.csv',
};
const figures = {
  '1.1': {
    title: 'HIV Test Episodes for %(ha)s',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 10,
      fha: 1,
      iha: 1,
      nha: 0.2,
      vcha: 5,
      viha: 1,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 300,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 80,
  },
  '1.2': {
    title: 'HIV Test Episodes by Gender for %(ha)s <sup style="font-size: 10px;">1, 2</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 10,
      fha: 1,
      iha: 1,
      nha: 0.3,
      vcha: 2,
      viha: 0.5,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 650,
    height: 290,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 100,
  },
  '1.3': {
    title: 'HIV Test Episodes by Age Category for %(ha)s <sup style="font-size: 10px;">1, 2</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 3,
      fha: 0.4,
      iha: 0.3,
      nha: 0.1,
      vcha: 2,
      viha: 0.2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 650,
    height: 400,
    marginLeft: 100,
    marginRight: 60,
    marginBottom: 110,
  },
  '1.4': {
    title: 'Point-of-Care HIV Tests for %(ha)s',
    yTitle: {
      bc: '# Point-of-Care HIV Tests<br>(thousands)',
      fha: '# Point-of-Care HIV Tests',
      iha: '# Point-of-Care HIV Tests',
      nha: '# Point-of-Care HIV Tests',
      vcha: '# Point-of-Care HIV Tests<br>(thousands)',
      viha: '# Point-of-Care HIV Tests',
    },
    yTickInterval: {
      bc: 0.2,
      fha: 100,
      iha: 40,
      nha: 20,
      vcha: 0.2,
      viha: 100,
    },
    yLabelsFormat: {
      bc: '{value:.1f}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value:.1f}',
      viha: '{value}',
    },
    width: 650,
    height: 350,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 80,
  },
  '1.5': {
    title: 'HIV Test Episodes for %(ha)s by %(group)s <sup style="font-size: 10px;">1</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 3,
      fha: 0.5,
      iha: 0.3,
      nha: 0.2,
      vcha: 3,
      viha: 0.3,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 740,
    height: 900,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 120,
  },
  '1.6': {
    title: 'HIV Test Episodes for Non-prenatal Females in %(ha)s by %(group)s <sup style="font-size: 10px;">1</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 2,
      fha: 0.4,
      iha: 0.2,
      nha: 0.1,
      vcha: 2,
      viha: 0.2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 740,
    height: 440,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 120,
  },
  '1.7': {
    title: 'HIV Test Episodes for Males in %(ha)s by %(group)s <sup style="font-size: 10px;">1</sup>',
    yTitle: '# HIV Test Episodes<br>(thousands)',
    yTickInterval: {
      bc: 2,
      fha: 0.4,
      iha: 0.3,
      nha: 0.1,
      vcha: 2,
      viha: 0.2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 740,
    height: 440,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 120,
  },
  '2.1': {
    title: 'Rate of HIV Testing for %(ha)s and %(group)s <sup style="font-size: 10px;">2</sup>',
    yTitle: 'HIV Testing Episodes per 100,000 Population',
    yTickInterval: {
      bc: 1000,
      fha: 200,
      iha: 500,
      nha: 400,
      vcha: 1000,
      viha: 300,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 740,
    height: 430,
    marginLeft: 150,
    marginRight: 170,
    marginBottom: 120,
  },
  '2.2': {
    title: 'Rate of HIV Testing by Gender for %(ha)s <sup style="font-size: 10px;">2</sup>',
    yTitle: 'HIV Testing Episodes per 100,000 Population',
    yTickInterval: {
      bc: 300,
      fha: 200,
      iha: 200,
      nha: 200,
      vcha: 1000,
      viha: 200,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 740,
    height: 420,
    marginLeft: 100,
    marginRight: 170,
    marginBottom: 80,
  },
  '2.3': {
    title: 'Rate of HIV Testing by Age Category for %(ha)s <sup style="font-size: 10px;">2</sup>',
    yTitle: 'HIV Testing Episodes per 100,000 Population',
    yTickInterval: {
      bc: 500,
      fha: 300,
      iha: 400,
      nha: 300,
      vcha: 1000,
      viha: 300,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 640,
    height: 870,
    marginLeft: 100,
    marginRight: 60,
    marginBottom: 100,
  },
  '3.1': {
    title: 'New HIV Diagnoses for %(ha)s <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 2,
      iha: 2,
      nha: 1.5,
      vcha: 10,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 250,
    marginLeft: 130,
    marginRight: 60,
    marginBottom: 90,
  },
  '3.2': {
    title: 'New HIV Diagnoses for %(ha)s by Gender <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 5,
      iha: 2,
      nha: 2,
      vcha: 10,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 350,
    marginLeft: 100,
    marginRight: 60,
    marginBottom: 90,
  },
  '3.3': {
    title: 'New HIV Diagnoses for %(ha)s by Age Category <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 2,
      iha: 2,
      nha: 2,
      vcha: 4,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 380,
    marginLeft: 100,
    marginRight: 90,
    marginBottom: 110,
  },
  '3.4': {
    title: 'New HIV Diagnoses for %(ha)s by Exposure Category <sup style="font-size: 10px;">3, 4</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 5,
      fha: 2,
      iha: 2,
      nha: 1,
      vcha: 5,
      viha: 3,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 650,
    height: 440,
    marginLeft: 100,
    marginRight: 90,
    marginBottom: 120,
  },
  '3.5': {
    title: 'New HIV Diagnoses for %(ha)s by %(group)s <sup style="font-size: 10px;">3</sup>',
    yTitle: '# HIV Diagnoses',
    yTickInterval: {
      bc: 10,
      fha: 3,
      iha: 1,
      nha: 2,
      vcha: 10,
      viha: 2,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 740,
    height: 870,
    marginLeft: 140,
    marginRight: 170,
    marginBottom: 170,
  },
  '4.1': {
    title: 'Stage of HIV Infection at Diagnosis for %(ha)s <sup style="font-size: 10px;">5</sup>',
    yTitle: '',
    width: 300,
    height: 390,
  },
  '4.2': {
    title: 'Stage of HIV Infection at Diagnosis by Gender for %(ha)s <sup style="font-size: 10px;">5</sup>',
    yTitle: '',
    width: 370,
    height: 380,
    marginTop: 60,
    marginRight: 1,
  },
  '4.3': {
    title: 'Stage of HIV Infection at Diagnosis by Age for %(ha)s <sup style="font-size: 10px;">5</sup>',
    yTitle: '',
    width: 710,
    height: 355,
    marginTop: 60,
  },
  '4.4': {
    title: 'Stage of HIV Infection at Diagnosis by Exposure Category for %(ha)s <sup style="font-size: 10px;">5, 6</sup>',
    yTitle: '',
    width: 532,
    height: 355,
    marginTop: 60,
  },
  '5.1': {
    title: 'Estimated Cascade of Care for %(ha)s, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">7</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -40,
      nha: -40,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 70,
      nha: 70,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -85,
      fha: -55,
      iha: -85,
      nha: -85,
      vcha: -85,
      viha: -85,
    },
    width: 330,
    height: 390,
    marginTop: 100,
    marginLeft: {
      bc: 110,
      fha: 130,
      iha: 110,
      nha: 110,
      vcha: 110,
      viha: 110,
    },
  },
  '5.2': {
    title: 'Estimated Cascade of Care for %(ha)s by Gender, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">7</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -40,
      nha: -40,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 70,
      nha: 70,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -100,
      fha: -100,
      iha: -100,
      nha: -100,
      vcha: -100,
      viha: -100,
    },
    width: 380,
    height: 390,
    marginTop: 100,
  },
  '5.3': {
    title: 'Estimated Cascade of Care for %(ha)s by Age Category, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">8</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -40,
      iha: -40,
      nha: -60,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 70,
      iha: 70,
      nha: 62,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -130,
      fha: -130,
      iha: -130,
      nha: -165,
      vcha: -130,
      viha: -130,
    },
    width: 720,
    height: 500,
    marginTop: 60,
    marginLeft: 110,
  },
  '5.4': {
    title: 'Estimated Cascade of Care for %(ha)s by MSM Status, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -40,
      nha: -60,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 70,
      nha: 62,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -125,
      fha: -75,
      iha: -125,
      nha: -160,
      vcha: -125,
      viha: -125,
    },
    width: 720,
    height: 500,
    marginTop: 80,
    marginLeft: {
      bc: 100,
      fha: 100,
      iha: 100,
      nha: 110,
      vcha: 100,
      viha: 100,
    },
  },
  '5.5': {
    title: 'Estimated Cascade of Care for %(ha)s by Age Category and MSM Status, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -60,
      fha: -40,
      iha: -100,
      nha: -100,
      vcha: -60,
      viha: -80,
    },
    yAxisHeight: {
      bc: 60,
      fha: 70,
      iha: 50,
      nha: 50,
      vcha: 60,
      viha: 60,
    },
    xAxisLabelsY: {
      bc: -100,
      fha: -100,
      iha: -100,
      nha: -100,
      vcha: -100,
      viha: -100,
    },
    width: 950,
    height: 530,
    marginTop: 80,
    marginLeft: 110,
  },
  '5.6': {
    title: 'Estimated Cascade of Care for %(ha)s by PWID Status, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -60,
      fha: -40,
      iha: -40,
      nha: -40,
      vcha: -40,
      viha: -40,
    },
    yAxisHeight: {
      bc: 60,
      fha: 70,
      iha: 70,
      nha: 70,
      vcha: 70,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -165,
      fha: -125,
      iha: -125,
      nha: -125,
      vcha: -125,
      viha: -125,
    },
    width: 720,
    height: 500,
    marginTop: 80,
    marginLeft: 110,
  },
  '5.7': {
    title: 'Estimated Cascade of Care for %(ha)s by %(group)s, Year Ending %(lastYear)s Q%(lastQuarter)s <sup style="font-size: 10px;">9</sup>',
    yTitle: '',
    yAxisMin: {
      bc: -40,
      fha: -20,
      iha: -60,
      nha: -60,
      vcha: -20,
      viha: -40,
    },
    yAxisHeight: {
      bc: 70,
      fha: 83,
      iha: 60,
      nha: 60,
      vcha: 83,
      viha: 70,
    },
    xAxisLabelsY: {
      bc: -145,
      fha: -80,
      iha: -185,
      nha: -185,
      vcha: -80,
      viha: -140,
    },
    width: 950,
    height: 530,
    marginTop: 60,
    marginLeft: {
      bc: 100,
      fha: 100,
      iha: 100,
      nha: 110,
      vcha: 100,
      viha: 100,
    },
  },
  '6.1': {
    title: 'PCS Components for %(ha)s, %(period)s <sup style="font-size: 10px;">10</sup>',
    yTitle: 'Percentage',
    yTickInterval: {
      bc: 2,
      fha: 5,
      iha: 5,
      nha: 5,
      vcha: 2,
      viha: 10,
    },
    yLabelsFormat: {
      bc: '{value}',
      fha: '{value}',
      iha: '{value}',
      nha: '{value}',
      vcha: '{value}',
      viha: '{value}',
    },
    width: 680,
    height: 400,
    marginLeft: 100,
    marginRight: 180,
    marginBottom: 80,
  },
  '6.2': {
    title: 'Historical Trends for PCS Score for %(ha)s, %(period)s <sup style="font-size: 10px;">10, 11</sup>',
    yTitle: 'Distribution of PCS Score',
    width: 510,
    height: 380,
    marginLeft: 100,
    marginBottom: 80,
  },
  '7': {
    title: 'BC-CfE Drug Treatment Program Enrollment New ART Participants in %(ha)s, %(period)s <sup style="font-size: 10px;">12</sup>',
    yTitle: '# Participants',
    yTickInterval: {
      bc: 20,
      fha: 10,
      iha: 2,
      nha: 2,
      vcha: 2,
      viha: 10,
    },
    width: 600,
    height: 210,
    marginLeft: 100,
    marginRight: 300,
  },
  '8': {
    title: 'CD4 Cell Count at ART Initiation of ART-Naïve DTP Participants in %(ha)s, %(period)s <sup style="font-size: 10px;">13</sup>',
    yTitle: '% in CD4 Cell Count Category at ART Initiation',
    y2Title: 'Median CD4 Cell Count at ART Initiation (cells/µL)',
    width: 480,
    height: 350,
    marginLeft: 110,
    marginRight: 110,
    marginBottom: 80,
  },
  '9': {
    title: 'Active and Inactive DTP Participants in %(ha)s, %(period)s <sup style="font-size: 10px;">15</sup>',
    yTitle: '# Participants',
    width: 660,
    height: 300,
    marginLeft: 100,
    marginRight: 200,
  },
  '10': {
    title: 'Distribution of Individuals by Adherence Level in 1st Year of Therapy, Based on Pharmacy Refill Compliance for %(ha)s, %(period)s <sup style="font-size: 10px;">16</sup>',
    yTitle: '% Achieving Prescription Refill Adherence',
    width: 600,
    height: 580,
    marginLeft: 80,
    marginRight: 200,
    marginBottom: 80,
  },
  '11': {
    title: 'Cumulative Resistance Testing Results by Resistance Category for %(ha)s, %(period)s <sup style="font-size: 10px;">17</sup>',
    yTitle: '% DTP Patients',
    width: 600,
    height: 550,
    marginLeft: 160,
    marginRight: 100,
    marginBottom: 80,
  },
  '12': {
    title: 'AIDS Case Rate and Reports for %(ha)s <sup style="font-size: 10px;">18</sup>',
    yTitle: 'Rate per 100,000 population',
    yTickInterval: {
      bc: 0.5,
      fha: 0.5,
      iha: 0.5,
      nha: 0.5,
      vcha: 1,
      viha: 0.5,
    },
    yLabelsFormat: {
      bc: '{value:.1f}',
      fha: '{value:.1f}',
      iha: '{value:.1f}',
      nha: '{value:.1f}',
      vcha: '{value}',
      viha: '{value:.1f}',
    },
    width: 600,
    height: 370,
    marginLeft: 180,
    marginRight: 160,
    marginBottom: 120,
  },
};
const colors = {
  text: '#2c3e50',
  axisLine: '#231f20',
  plotBackground: '#e1e2e4',
  gridLineColor: '#ffffff',
  cascadePoints: ['', '#043f61', '#0c4250', '#0d4440', '#09472e', '#0a4a23'],
  stackedColumnSeries: ['#6bcff6', 'url(#polka-dot-1)', 'url(#polka-dot-2a)', 'url(#polka-dot-2b)', '#9d070d'],
  lineSeries: ['#0076a3', '#9d0140', '#ab9f01', '#2b7025', '#560054', '#9d070d'],
  lineSingle: '#231f20',
};

module.exports = {
  figures: figures,
  allHealthAuthorities: allHealthAuthorities,
  healthAuthorities: healthAuthorities,
  colors: colors,
  inputFiles: inputFiles,
};



//////////////////
// WEBPACK FOOTER
// ./src/cli/constants.js
// module id = 35
// module chunks = 0